module.exports = __webpack_public_path__ + "img/androidBtn.303ca3db.png";